// extracted by mini-css-extract-plugin
module.exports = {"header":"modal-filter_header__nM0Fr","headerTitle":"modal-filter_headerTitle__9ukE2","resetFilter":"modal-filter_resetFilter__2oeeU"};